<template>
    <div class="set-component">
        <div class="set-header">关于我们</div>
        <div class="set-body about-content">
            <div class="about-logo">
                <img :src="logo" alt="logo" />
            </div>
            <h2>{{ appName }}</h2>
            <p class="version">版本：v{{ version }}</p>
            <p class="desc">
                {{ appName }} 是一个内容分享与交流平台，致力于为用户提供优质的内容发现、创作与社交体验。
            </p>
            <div class="links">
                <a>官方网站</a>
                <a>用户协议</a>
                <a>隐私政策</a>
                <a>联系我们</a>
            </div>
            <button class="feedback-btn" @click="handleFeedback">意见与反馈</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AboutUs',
    data() { return { appName: '小桃网', version: '1.0.0', logo: require('@/assets/xiaotaowang.jpg') }; },
    methods: {
        handleFeedback() {
            this.$router.push('/helpFeedbackView');
        }
    }
};
</script>

<style scoped>
.set-component { background: var(--card-background); border-radius: 12px; border: 1px solid var(--border-color-lighter); }
.set-header { padding: 18px 24px; font-size: 16px; font-weight: 600; color: var(--text-color); border-bottom: 1px solid var(--border-color-lighter); }
.set-body { padding: 40px 24px; text-align: center; }
.about-logo img { width: 80px; height: 80px; border-radius: 16px; }
h2 { margin: 16px 0 8px; font-size: 18px; color: var(--text-color); }
.version { font-size: 13px; color: var(--text-color-muted); }
.desc { font-size: 14px; color: var(--text-color-secondary); line-height: 1.7; margin: 20px auto; max-width: 500px; }
.links { display: flex; justify-content: center; gap: 20px; margin-top: 20px; }
.links a { color: var(--theme-color); font-size: 13px; cursor: pointer; }
.feedback-btn {
    margin-top: 24px;
    padding: 10px 28px;
    border: none;
    border-radius: 6px;
    background: var(--theme-color, #409EFF);
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s ease;
}
.feedback-btn:hover {
    filter: brightness(1.1);
}
</style>
